interface AdminCrmViewNavigationProps {
  readonly current: "leads" | "pipeline";
}

const crmViews = [
  { id: "leads", label: "Lead list", href: "/admin/crm/leads" },
  { id: "pipeline", label: "Pipeline", href: "/admin/crm/pipeline" },
] as const;

export function AdminCrmViewNavigation({
  current,
}: AdminCrmViewNavigationProps) {
  return (
    <nav className="crm-view-navigation" aria-label="CRM views">
      <ul>
        {crmViews.map((view) => (
          <li key={view.id}>
            <a
              href={view.href}
              aria-current={view.id === current ? "page" : undefined}
            >
              {view.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
